<template>
    <div class="search-results row p-3" v-if="results.length">
        <table class="table col-12">
            <tbody class="list">
                <tr
                    v-for="item in results"
                    :key="item.id"
                >
                    <td
                        v-for="(attribute, index) in attributes"
                        :key="index"
                    >
                        <router-link
                            :to="{ path: composeEditLink(item) }"
                            class="link"
                            v-if="attribute === 'title_NL'"
                        >
                            {{ item[attribute] | uppercase }}
                        </router-link>
                        <span v-else>{{ getValue(item, attribute) }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    results: {
      type: Array,
      required: true
    },
    attributes: {
      type: Array,
      required: false
    }
  },
  methods: {
    composeEditLink (item) {
      return '/services/' + item.serviceType.code.toLowerCase() + '/' + item.id
    },
    getValue (item, attribute) {
      if (typeof item[attribute] === 'object' && item[attribute] !== null) {
        if (item[attribute].hasOwnProperty('name_NL')) {
          return item[attribute].name_NL
        } else {
          return item[attribute].id
        }
      } else {
        return item[attribute]
      }
    }
  }
}
</script>
<style>
    .link {
        color: #0099E5 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/search/list/Service.vue